export default "/images/vendor/flag-icon-css/flags/4x3/af.svg?458ab7e0c32d14aefe334255c26dc561";